import Vue from "vue";
import Router from "vue-router";
import ClientManagement from "@/components/ClientManagement/ClientManagement";
import LocationManagement from "@/components/LocationManagement/LocationManagement";
import LocationImport from "@/components/LocationManagement/LocationImport";
import UserManagement from "@/components/UserManagement";
import ProjectManagement from "@/components/ProjectManagement/ProjectManagement";
import AgencyManagement from "@/components/AgencyManagement/AgencyManagement";
import SurveyManagement from "@/components/SurveyManagement/SurveyManagement";
import CheckManagement from "@/components/CheckManagement/CheckManagement";
import KPIManagement from "@/components/KPIManagement/KPIManagement";
import PageNotFound from "@/components/PageNotFound";
import ShopperManagement from "@/components/ShopperManagement/ShopperManagement";
import ShopperCheckManagement from "@/components/ShopperManagement/ShopperCheckManagement";
import Recruiting from "@/components/Recruiting/Recruiting";
import ShopperApproval from "@/components/ShopperApproval/ShopperApproval";
import UserSettings from "@/components/UserSettings";

import feature from "../feature";

Vue.use(Router);

let routes = [
  // Routes to the different components are registered here
  {
    path: "/clientmanagement",
    name: "ClientManagement",
    component: ClientManagement,
  },
  {
    path: "/locationmanagement",
    name: "LocationManagement",
    component: LocationManagement,
  },
  {
    path: "/locationimport/:clientGuid",
    name: "LocationImport",
    component: LocationImport,
  },
  {
    path: "/usermanagement",
    name: "UserManagement",
    component: UserManagement,
  },
  {
    path: "/projectmanagement",
    name: "ProjectManagement",
    component: ProjectManagement,
  },
  {
    path: "/agencymanagement",
    name: "AgencyManagement",
    component: AgencyManagement,
  },
  {
    path: "/surveymanagement",
    name: "SurveyManagement",
    component: SurveyManagement,
  },
  {
    path: "/checkmanagement",
    name: "CheckManagement",
    component: CheckManagement,
  },
  {
    path: "/kpimanagement",
    name: "KPIManagement",
    component: KPIManagement,
  },
  {
    path: "/recruiting",
    name: "Recruiting",
    component: Recruiting,
  },
  {
    path: "/shoppermanagement",
    name: "ShopperManagement",
    component: ShopperManagement,
  },
  {
    path: "/shoppermanagement/checks",
    name: "ShopperCheckManagement",
    props: (route) => ({
      selectedShopperGuid: route.query.selectedShopperGuid,
    }),
    component: ShopperCheckManagement,
  },
  {
    path: "/surveycode",
    name: "SurveyCodeLogin",
  },
  {
    path: "/surveycode/:sc",
    name: "SurveyCodeDirectLogin",
  },
  {
    path: "/callback",
    name: "DirectToLoginCallback",
  },
  {
    path: "/logout_callback",
    name: "DirectToLogoutCallback",
  },
];

if (feature.isEnabled("userSettings"))
  routes.push({
    path: "/settings",
    name: "UserSettings",
    component: UserSettings,
  });
if (feature.isEnabled("shopperApproval"))
  routes.push({
    path: "/shopperapproval",
    name: "ShopperApproval",
    component: ShopperApproval,
  });

routes.push({
  path: "*",
  name: "PageNotFound",
  component: PageNotFound,
});

export default new Router({
  //mode: 'history',
  routes: routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js